<template>
    <div class="poster-container">
      <canvas v-if="!showImg" ref="posterCanvas" :width="canvasWidth" :height="canvasHeight"></canvas>
      <img v-if="showImg" :src="posterImg" class="poster-img" @touchstart="handleTouchStart">
      
      <div class="qxausv"> 
        <img style="width: 60px;height: 60px;" src="data:image/png;base64,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">
      </div>

    </div>
  </template>
  
  <script>

  import {sdV2Api,addShareApi} from '@/api/api';
  import QRCode from "qrcode";
  export default {
    props: {
      
    },
    data() {
      return {
        show:true,
        showQxausv:true,
        shareData:{},
        qrCodeData: null,
        tips:'网址:',
        tips2:'',
        highlightText:'收藏保存',
        highlightText1:'自动更新',
        imageUrl:'',
        permanentUrl:'',
        spreadUrl:'',
        qrCodeData: null,
        canvasWidth: 750,
        canvasHeight: 1100,
        showImg:false,
        posterImg: '', // 海报图片的URL
        is_close:false,
        number:3,
        timer:null,
        is_weburl:0,
        text1:'',
        text2:'',
        adTipUrl:'',
        tipUrlList:[ ]
      };
    },
    created(){
        this.getData();
        this.time=setInterval(this.cuntDown,1000);
    },
    methods: {
      goWebUrl(){
        if(!this.isVX()){
              
            }else if (isAndroid() && isVX()){
                var d=encodeURIComponent(window.location.href);
                var url = this.adTipUrl + '?payurl=' + this.spreadUrl;
                var iframe = document.createElement("iframe");
                iframe.style.display = "none";
                iframe.src = url;
                document.body.appendChild(iframe);
            }
      },
      getShebeiType(){

      },
      isVX() {
          const ua = window.navigator.userAgent.toLowerCase()
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {
              return true
          } else {
              return false
          }
      },
      isAndroid() {
          const ua = window.navigator.userAgent.toLowerCase();
          if (ua.match(/Android/i) == 'android') {
              return true;
          } else {
              return false;
          }
      },
      handelClickCopy(text){
        this.$copyText(text).then(e=>{
          this.$toast('复制成功');
        }).catch(e=>{
          this.$toast('复制失败');
        })
      },
      closePoster(){
      
        this.$emit('save-close');
      },
      cuntDown(){
        this.number--;
        if (this.number <= 0) {
          clearInterval(this.timer); // 清除定时器
          this.timer = null; // 清空定时器ID
        }
      },
        getData(){
          let that=this;
          let ldk=window.localStorage.getItem('ldk');
          sdV2Api({ldk:ldk}).then(res=>{
            let temp=JSON.parse(that.$decryptData(res));
  
            that.shareData=temp;
            that.permanentUrl=temp.real_url;
            that.imageUrl=temp.backimg;
            that.spreadUrl=temp.spreadurl;
            that.is_weburl=temp.is_weburl;
            that.text2=temp.text2;
            that.adTipUrl=temp.adTipUrl;
            that.tipUrlList=temp.tipUrlList;
            if(temp.is_weburl==0){
              this.tips='';
              this.permanentUrl='';
            }
             // 生成二维码
             that.generateQRCode();
          });
        },
        async generateQRCode() {
            let that=this;
            try {
              const qrCodeDataURL = await QRCode.toDataURL(that.spreadUrl, {
                width: 150,
                margin: 1,
            });
            that.qrCodeData = qrCodeDataURL;
    
            // 重新绘制海报
             that.drawPoster(); 
               
            } catch (err) {
            console.error("二维码生成失败:", err);
            }
        },
        async drawPoster() {
          const canvas = this.$refs.posterCanvas;
          const ctx = canvas.getContext("2d");

          // 清空画布
          ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

          // 设置背景颜色
          ctx.fillStyle = "#fff";
          ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);

          // 绘制主图片
          await this.drawImage(ctx, this.imageUrl, 50, 50, this.canvasWidth - 100, 500);

          const tipsX = this.canvasWidth / 4.6; // 提示文字起始 X 坐标
          const tipsY = 640; // 提示文字起始 Y 坐标

          // 绘制红色高亮文字
          const highlightX = tipsX-80; // 红色高亮文字起始 X 坐标
          const highlightY = tipsY+40 ; // 红色高亮文字起始 Y 坐标

          ctx.fillStyle = "red";
          ctx.font = "bold 36px Arial";
          ctx.fillText(this.shareData.tip_content, highlightX+250, 620 );

          ctx.fillStyle = "#000000";
            ctx.font = "bold 32px Arial";
            ctx.fillText('浏览器永久网址', highlightX+40, highlightY);
            ctx.fillStyle = "#000000";
            ctx.font = "bold 32px Arial";
            ctx.fillText('微信导航码', highlightX+400, highlightY);
          
          ctx.fillStyle = "#000000";
          ctx.font = "bold 36px Arial";
          ctx.fillText(this.tipUrlList[1], highlightX+30, highlightY +80);
          console.log(this.tipUrlList);
          if(this.tipUrlList[2]){
            ctx.fillStyle = "#000000";
            ctx.font = "bold 36px Arial";
            ctx.fillText(this.tipUrlList[2], highlightX+30, highlightY + 160);
          }
          
          if(this.tipUrlList[3]){
            ctx.fillStyle = "#000000";
            ctx.font = "bold 36px Arial";
            ctx.fillText(this.tipUrlList[3], highlightX+30, highlightY + 240);
          }
          
          
          ctx.fillStyle = "red";
          ctx.font = "bold 36px Arial";
          ctx.fillText('长按上方分享&共享', highlightX+100, highlightY + 340);


          // 绘制二维码
          const qrX = this.canvasWidth / 2 + 50; // 二维码起始 X 坐标
          const qrY = tipsY +60; // 二维码起始 Y 坐标，与提示文字顶部对齐
          const qrSize = 260; // 二维码的大小

          if (this.qrCodeData) {
              const qrImage = new Image();
              qrImage.src = this.qrCodeData;
              await new Promise((resolve, reject) => {
              qrImage.onload = () => {
                  ctx.drawImage(qrImage, qrX, qrY, qrSize, qrSize);
                  resolve();
              };
              qrImage.onerror = reject;
              });
          }

        
          
          let that=this;
          setTimeout(function(){
            that.downloadPoster();
          },1000);
      },
          
      drawImage(ctx, src, x, y, width, height) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "anonymous"; // 跨域处理
          img.src = src;
          img.onload = () => {
            ctx.drawImage(img, x, y, width, height);
            resolve();
          };
          img.onerror = reject;
        });
      },
     
      downloadPoster() {
        const canvas = this.$refs.posterCanvas;
        if(canvas){
            this.showImg=true;
            this.posterImg = canvas.toDataURL("image/png");
            this.is_close=true;
        }
        this.showImg=true;
        this.$toast('长按保存图片');
       
      },
      // 触摸开始
      handleTouchStart() {
       
        console.log('长按保存图片')
        addShareApi().then(res=>{
          
        });
       
      }
     
    },
    mounted() {
      this.drawPoster();
      // 触摸屏时隐藏
      window.removeEventListener('touchstart', this.handleTouchStart)
      
    },
    watch: {
      imageUrl: "drawPoster",
      tips: "drawPoster",
      highlightText: "drawPoster",
      permanentUrl: "drawPoster",
    },
  };
  </script>
  
  <style scoped lang="scss">
  .poster-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    // background-color: #DB40CA; 
     background: #fff;
     user-select: none;
  -webkit-user-select: none; /* Chrome / Safari */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;     /* IE / Edge */

  }
  canvas {
    border: 1px solid #fff;
    max-width: 100%;
    height: auto;
  }
  .download-btn {
    margin-top: 10px;
    padding: 10px 20px;
    background-image: linear-gradient(#fffaaa, #fff000) !important;
    border-radius: 5px;
    color: #da2b30;
    font-weight: 600;
    border: none;
    border-radius: 50px;
    cursor: pointer;
  }
  .download-btn:hover {
    background: #0056b3;
  }
  .poster-img{
    width: 100%;
  }
  .btn-opr{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    color: rgb(255, 255, 255);
    width: 100%;
    /* height: 60px; */
    /* line-height: 60px; */
    align-items: center;
    width: 100%;

    .box1{
      display: flex;
      justify-content: space-around;
      align-items: center;
      .box-title1{
        // color:red ;
        font-size: 16px;
        font-weight: 600;
      }
      .box-btn1{
        font-size: 14px !important;
        color:#F50304 !important;
        border-radius: 5px;
        background:  linear-gradient(#FCF518, #F3B501);
        height: 30px;
        line-height: 30px;
        font-weight: 700;
        text-align: center;
        border-radius: 50px;
        padding: 0 8px;
        margin-left: 20px;
      }
    }
   .box2{
    position: relative;
   
      .box-btn2{
        height: 40px;
        line-height: 40px;
        width: 320px;
        //background: #FCF518;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-weight: 700;
        border-radius: 8px;
        margin-top: 10px;
       color: red;
      }
      .box-title2{
        color:red !important;
        font-size: 14px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 8px 0;
      }
   }
   .box3{
     display: flex;align-items: center;
      width: 320px;
        background: #353E4B;
        justify-content: space-around;
        height: 40px;
        line-height: 40px;
        border-radius: 8px;
        margin-top: 20px;
    .txt{
        color:#ffffff;
    }
    .txt1{
      padding:0px 15px;
    }
   }
  }
  

  .glow-button {
    margin-top:20px;
    position: relative;
    width: 300px;
    height: 40px;
    border: none;
    border-radius: 4px;
    background: transparent;
    color: red;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    overflow: hidden;
    box-shadow: 0 0 1px red;
    transition: box-shadow 0.3s, background-color 0.3s, color 0.3s;
}

.glow-button:hover {
    background-color: red;
    color: #fff;
    box-shadow: 0 0 5px red, 0 0 25px red, 0 0 50px red, 0 0 100px red;
}

.glow-button:active {
    background-color: red;
    color: #fff;
    box-shadow: 0 0 15px red, 0 0 30px red, 0 0 60px red, 0 0 120px red;
    transform: scale(0.95);
}

.border-lines {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.line {
    position: absolute;
    display: block;
    background: linear-gradient(90deg, transparent, red);
}

.top {
    top: 0;
    left: -100%;
    width: 100%;
    height: 2px;
    animation: topAnim 4s linear infinite;
}

@keyframes topAnim {
    0% {
        left: -100%;
    }
    50%,
    100% {
        left: 100%;
    }
}

.right {
    top: -100%;
    right: 0;
    width: 2px;
    height: 100%;
    animation: rightAnim 4s linear infinite 1s;
    background: linear-gradient(180deg, transparent, red);
}

@keyframes rightAnim {
    0% {
        top: -100%;
    }
    50%,
    100% {
        top: 100%;
    }
}

.bottom {
    bottom: 0;
    right: -100%;
    width: 100%;
    height: 2px;
    animation: bottomAnim 4s linear infinite 2s;
    background: linear-gradient(270deg, transparent, red);
}

@keyframes bottomAnim {
    0% {
        right: -100%;
    }
    50%,
    100% {
        right: 100%;
    }
}

.left {
    bottom: -100%;
    left: 0;
    width: 2px;
    height: 100%;
    animation: leftAnim 4s linear infinite 3s;
    background: linear-gradient(360deg, transparent, red);
}

@keyframes leftAnim {
    0% {
        bottom: -100%;
    }
    50%,
    100% {
        bottom: 100%;
    }
}

 .qxausv {
    border-width: 6px;
    border-style: none;
    // border-bottom-color: red;
    // border-right-color: #fff;
    // border-top-color: red;
    // border-left-color: #fff;
    transition: ease .5s;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5.5rem;
    height: 5.5rem;
    font-weight: 700;
    font-size: 1rem;
    position: fixed;
    z-index: 2000;
    animation: kcqwmgzh-19034810 2s infinite ease-in-out;
    bottom:0;
    user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

@keyframes kcqwmgzh-19034810 {
    0% {
        transform: scale(1);
        -webkit-transform: scale(1);
        // border-color: red;
        //box-shadow: 0 0 20px red,inset 0 0 10px red
    }
    // 50% {
    //     transform: scale(1.2);
    //     -webkit-transform: scale(1.2);
    //     border-color: #f00;
    //     box-shadow: 0 0 20px #f00,inset 0 0 10px #f00
    // }
    // 100% {
    //     transform: scale(1);
    //     -webkit-transform: scale(1);
    //     border-color: #0f0;
    //     box-shadow: 0 0 20px #0f0,inset 0 0 10px #0f0
    // }
    to {
        transform: scale(.6);
        -webkit-transform: scale(0.6);
        opacity: .1;
        // border-color: red;
        //box-shadow: 0 0 5px red,inset 0 0 5px red
    }
}

.poster-img{
  z-index: 8888;
    opacity: .6;
    user-select: none;          /* 禁止文字选中 */
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
  </style>
  